import type { Agent, Conversation } from '../types';
import { generateUUID } from '../utils/uuid';

export const STATIC_AGENTS: Agent[] = [
  {
    id: 'omega-wolf',
    label: 'Digital Wolf Agency',
    description: 'General assistant',
  },
];

export const DEFAULT_AGENT_ID = STATIC_AGENTS[0]?.id ?? '';

export const DEFAULT_CONVERSATION_TITLE = 'New Chat';

export const createEmptyConversation = (
  agentId: string,
  communityLabel?: string,
  clientId?: string
): Conversation => ({
  id: generateUUID(),
  sessionId: generateUUID(),
  agentId,
  title: DEFAULT_CONVERSATION_TITLE,
  createdAt: new Date(),
  updatedAt: new Date(),
  messages: [],
  communityLabel,
  clientId: clientId ?? 'dwa-internal',
});

export const deriveConversationTitle = (content: string): string => {
  const trimmed = content.trim();
  if (!trimmed) {
    return DEFAULT_CONVERSATION_TITLE;
  }
  return trimmed.length > 40 ? `${trimmed.slice(0, 37)}...` : trimmed;
};

export const sortConversationsByUpdatedAt = (list: Conversation[]): Conversation[] =>
  [...list].sort(
    (a, b) => b.updatedAt.getTime() - a.updatedAt.getTime()
  );

export function readStoredClientId(): string {
  try {
    return localStorage.getItem('selectedClientId') ?? 'dwa-internal';
  } catch {
    return 'dwa-internal';
  }
}

export function storeClientId(id: string): void {
  try {
    localStorage.setItem('selectedClientId', id);
  } catch {
    /* storage unavailable — the in-memory value still applies */
  }
}
